import AccordionSwitch from "../functions/accordion";

// SCROLL BUTTON （ナビゲーション管理） 右下のボタン
//=======================================================/
$(window).on('load', function () {
    let navigation_count = 1;   // スクロールしたカウント数

    $('#scroll-btn').on('click', function () {
        // scrollFlg = true; // 必要これ？
        // 別にカーソルポインタのままでも良いのでは…？
        // $('#scroll-btn').css({
        //     'pointer-events': 'none'
        // });

        // 2回目以降はボタン画像を差し替え
        if (navigation_count === 1) {
            $('#scroll-btn .src-default').attr("src", "assets/image/footer/scroll_btn_2.png");
            $('#scroll-btn .src-active').attr("src", "assets/image/footer/scroll_btn_2_active.png");
        }

        // 各種数値、仕様のセクションに来たらアコーディオンを展開
        if ($('#navi' + navigation_count).parent("#value").length) {
            $('#value').find(".accordion-box").each(function (index, element) {
                new AccordionSwitch($(element), false);
            });
        }
        if ($('#navi' + navigation_count).parent("#spec").length) {
            $('#spec').find(".accordion-box").each(function (index, element) {
                new AccordionSwitch($(element), false);
            });
        }

        $('html, body').animate({
            scrollTop: $('#navi' + navigation_count).offset().top
        }, 500, "easeInOutCubic")
            .promise()
            .done(function () { // 必要これ？
                // scrollFlg = false; // 必要これ？
                // $('#scroll-btn').css({'pointer-events': 'auto'}); // 必要これ？
            });

        ++navigation_count; // count up

        // 見終わったらボタンの削除
        console.log($('#navi' + navigation_count).length);

        if (!$('#navi' + navigation_count).length) {
            $('#scroll-btn').remove();
        }
    });

});
